import PredictedFundingFailureBanner from './PredictedFundingFailureBanner';

export default PredictedFundingFailureBanner;
